import {
  useAddLeagueNamingKey,
  useAddTournamentNamingKey,
  useCanSeeOrganizationData,
  useScopedHref,
} from "@/hooks";
import { useT } from "@/i18n";
import { trackAction } from "@/lib/sentry";
import {
  Button,
  DialogTrigger,
  Dropdown,
  DropdownItem,
  IconBuilding,
  IconCalendar,
  IconExternalLink,
  IconNews,
  IconPlus,
  IconTrophy,
} from "@/ui";
import { getManagerHref } from "@/utils/common";

export const DashboardHeaderCreateButton = () => {
  const t = useT();
  const addLeagueNamingKey = useAddLeagueNamingKey();
  const addTournamentNamingKey = useAddTournamentNamingKey();
  const scopedHref = useScopedHref();
  const canSeeOrganizationData = useCanSeeOrganizationData();

  // Every create action targets the current platform/organization scope, so the
  // button is only useful to members of that scope — i.e. users who hold any
  // capability on it (strict RBAC; see docs/capabilities.md). The individual
  // create destinations are independently capability-gated.
  if (!canSeeOrganizationData) {
    return null;
  }

  return (
    <DialogTrigger
      onOpenChange={(isOpen) => {
        if (isOpen) trackAction("dashboard.header.create.open");
      }}
    >
      <Button variant="secondary" color="brand" startIcon={IconPlus} className="min-w-fit">
        {t("general.actions.create")}
      </Button>
      <Dropdown
        label={t("general.components.dropdown.labels.actions")}
        popoverProps={{
          className: "w-[252px]",
        }}
      >
        <DropdownItem
          label={t(addLeagueNamingKey("general.navigation.create.league"))}
          href={scopedHref("/tours/new")}
          startIcon={IconTrophy}
          onAction={() => trackAction("dashboard.header.create.league.select")}
        />
        <DropdownItem
          startIcon={IconCalendar}
          endIcon={IconExternalLink}
          label={t(addTournamentNamingKey("general.navigation.create.tournament"))}
          href={getManagerHref("/dashboard/all-tournaments/new")}
          onAction={() => trackAction("dashboard.header.create.tournament.select")}
        />
        <DropdownItem
          label={t("general.navigation.create.club")}
          href={scopedHref("/operators/new")}
          startIcon={IconBuilding}
          onAction={() => trackAction("dashboard.header.create.club.select")}
        />
        <DropdownItem
          label={t("general.navigation.create.news")}
          href={scopedHref("/news/new")}
          startIcon={IconNews}
          onAction={() => trackAction("dashboard.header.create.news.select")}
        />
      </Dropdown>
    </DialogTrigger>
  );
};
